import React, { useState } from "react";
import { ControlOutlined } from "@ant-design/icons";
import { Button, Checkbox, Dropdown, theme, Tooltip } from "antd";
import PropTypes from "prop-types";

export const EditColumns = ({
	columns = [], 
	activeColumns = [], 
	loading = false,
	onChangeColumns = () => {},
}) => {
	const { token : antToken } = theme.useToken();
	const [openDropdown, setOpenDropdown] = useState(false);
	
	const dropdownMenu = (
		<div
			style={{
				padding: "10px",
				width: "220px",
				background: antToken.colorBgBase,
				border: "1px solid #d9d9d9",
				borderRadius: "8px",
				boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
				maxHeight: "300px", 
				overflowY: "auto",
			}}
			onMouseLeave={() => setOpenDropdown(false)}
		>
			<Checkbox.Group
				options={columns
					.filter(col => col.title) // Filter out columns with no title
					.map((col) => ({
						label: col.title,
						value: col.dataIndex ?? "",
					}))}
				value={activeColumns}
				onChange={(selectedValues) => {
					// Ensure "sort" is always included in the selection
					if (!selectedValues.includes("sort")) {
						selectedValues.push("sort");
					}
					onChangeColumns(selectedValues);
				}}
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "8px",
				}}
			/>
		</div>
	);

	return (
		<Tooltip title="Editar Columnas">
			<Dropdown
				open={openDropdown}
				overlay={dropdownMenu}
				placement="bottomLeft"
				trigger={["click"]}
			>
				<Button
					type="primary"
					style={{ marginRight: "20px" }}
					onClick={(e) => {
						e.preventDefault();
						setOpenDropdown(!openDropdown);
					}}
					icon={<ControlOutlined />}
					loading={loading}
					ghost
				>
				</Button>
			</Dropdown>
		</Tooltip>
	);
};

EditColumns.displayName = "EditColumns";

EditColumns.propTypes = {
	columns: PropTypes.array.isRequired,
	activeColumns: PropTypes.array.isRequired,
	onChangeColumns: PropTypes.func,
	loading: PropTypes.bool,
};